import { request } from './request';
import { Email, EmailTransactionalMessage, EmailSend } from '@dev/ee-api/ee-api-models';
import { AxiosPromise } from 'axios';

export const sendEmail = (body: EmailTransactionalMessage): Promise<EmailSend> => {
    const { Emails } = request();

    return Emails.emailsTransactionalPost(body).then((resp) => resp.data);
};

export const emailsCancel = (): AxiosPromise<void> => {
    const { Emails } = request();

    return Emails.emailsCancelPost();
};

export const viewEmail = (msgid: string): AxiosPromise<Email> => {
    const { Emails } = request();

    return Emails.emailsByMsgidViewGet(msgid);
};
